define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll', 'lightbox', 'jump'],
    function ($, transit, modernizr, container, preloader, router, scroll, lightboxFactory, jumpFactory) {

        var module = (function () {

            var name = 'module-roblox';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            const lightbox = lightboxFactory.create();
            const jump = jumpFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {

            }

            /* view */

            view.publicVars = {};

            view.privateVars = {
                category: null,
                currentItem: '',
                categoryAnim: 0,

                videoSize: {
                    width: 900,
                    height: 506
                },
            };

            view.startup = function () {
                view.privateVars.category = view.publicVars.category;
                view.privateVars.currentItem = view.publicVars.currentItem;

                preloader.setPreloadBulk('module-roblox-start', view.publicVars.preloadTab);

                $(view.publicVars.cssId.robloxFrameIframeId).each(function () {
                    this.src = this.src;
                });

                $(view.publicVars.cssId.robloxVideoFrameWrapperCls).removeAttr('href');

                lightbox.setCloseCallback(function () {
                    $(view.publicVars.cssId.robloxFrameIframeId).attr('src', '');
                    $(view.publicVars.cssId.robloxFrameIframeId).removeAttr('src');

                    const metaTitle = container.getData($(view.publicVars.cssId.robloxButtonCategoryCls + view.privateVars.category)[0], 'meta.title');

                    router.enable();

                    router.route(view.publicVars.baseUrl + view.publicVars.slug
                        + '/' + view.privateVars.category, metaTitle);
                });

                if(view.privateVars.currentItem) {
                    view.methods.showLightbox('#' + view.publicVars.cssId.robloxVideoFrameWrapperCls.substr(1)
                        + view.privateVars.category + view.privateVars.currentItem);
                }
            };

            view.bind = function () {
                $(view.publicVars.cssId.robloxButtonCategoryCls).click(function () {
                    const id = container.getData($(this)[0], 'category');

                    if(id != view.privateVars.category && view.privateVars.categoryAnim == 0) {
                        view.privateVars.categoryAnim = 1;

                        view.methods.changeCategory(id, this);
                    }
                });

                $(view.publicVars.cssId.robloxVideoFrameWrapperCls).click(function () {
                    view.methods.showLightbox(this);

                    return false;
                });

                $(window).resize(() => {
                    if (lightbox.getStatus() === 1) {
                        view.methods.calculateLightboxSize(view.privateVars.videoSize.width, view.privateVars.videoSize.height);
                    }
                });

                $(window).on('orientationchange', () => {
                    if (lightbox.getStatus() === 1) {
                        view.methods.calculateLightboxSize(view.privateVars.videoSize.width, view.privateVars.videoSize.height);
                    }
                });
            };

            view.methods = {
                changeCategory: (id, handler) => {
                    const metaTitle = container.getData($(handler)[0], 'meta.title');
                    const hrefTop = container.getData($(handler)[0], 'href.top');
                    const windowWidth = $(window).outerWidth();

                    router.route(hrefTop, metaTitle);

                    $(view.publicVars.cssId.robloxButtonCategoryCls + view.privateVars.category).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    $(view.publicVars.cssId.robloxButtonCategoryCls + id).addClass(view.publicVars.cssId.isActiveCls.substr(1));

                    $(view.publicVars.cssId.robloxVideoFrameGridCatCls + view.privateVars.category).css({ display: 'none'});
                    $(view.publicVars.cssId.robloxVideoFrameGridCatCls + id).css({ display: 'block', opacity: 0, scaleX: 0, rotate: '0.01deg' });

                    if(windowWidth < 768) {
                        jump.centerTo(view.publicVars.cssId.robloxVideoFrameGridCatCls + id, {});
                    }
                    $(view.publicVars.cssId.robloxVideoFrameGridCatCls + id).transit({ opacity: 1, scaleX: 1, rotate: '0.01deg'}, 300, function () {
                        view.privateVars.categoryAnim = 0;
                        view.privateVars.category = id;
                    });

                    // $(view.publicVars.cssId.videoFrameGridCatCls + id).css({ display: 'block' });
                    // $(view.publicVars.cssId.videoFrameGridCatCls + id).animateCss('animate__fadeIn', function () {
                    //     view.privateVars.categoryAnim = 0;
                    //     view.privateVars.category = id;
                    // });
                },

                showLightbox: (handler) => {
                    const videoSrc = container.getData($(handler)[0], 'video.src');
                    const posterSrc = container.getData($(handler)[0], 'poster.src');
                    const slug = container.getData($(handler)[0], 'slug');
                    const metaTitle = container.getData($(handler)[0], 'meta.title');

                    const lightboxSize = view.methods.calculateLightboxSize(view.privateVars.videoSize.width, view.privateVars.videoSize.height);

                    router.route(view.publicVars.baseUrl + view.publicVars.slug
                        + '/' + view.privateVars.category + '/' + slug, metaTitle);

                    router.disable();

                    $(view.publicVars.cssId.robloxFrameIframeId).removeAttr('src');
                    $(view.publicVars.cssId.robloxFrameIframeId).css({ opacity: 0, scale: 0.5});
                    $(view.publicVars.cssId.robloxLightboxLoaderWrapperId).css({ display: 'block', opacity: 0, scale: 0, rotate: '0deg'});

                    lightbox.showLayer(function () {
                        $(view.publicVars.cssId.robloxLightboxLoaderWrapperId).transit({ opacity: 1, scale: 1, rotate: '360deg'}, 300, function () {

                            setTimeout(function () {
                                $(view.publicVars.cssId.robloxFrameIframeId)[0].src = videoSrc;
                                $(view.publicVars.cssId.robloxFrameIframeId)[0].poster = posterSrc;

                                const promise = $(view.publicVars.cssId.robloxFrameIframeId)[0].play();

                                promise.catch(err => {});

                                $(view.publicVars.cssId.robloxFrameIframeId).transit({ opacity: 1, scale: 1}, 300);
                            }, 500);

                        })
                    });
                },

                calculateLightboxSize: (width, height) => {

                    const windowWidth = $(window).width();
                    const windowHeight = $(window).height();

                    const paddingTop = parseInt($(view.publicVars.cssId.robloxLightboxAreaId).css('padding-top'));
                    const paddingBottom = parseInt($(view.publicVars.cssId.robloxLightboxAreaId).css('padding-bottom'));
                    const paddingLeft = parseInt($(view.publicVars.cssId.robloxLightboxAreaId).css('padding-left'));
                    const paddingRight = parseInt($(view.publicVars.cssId.robloxLightboxAreaId).css('padding-right'));

                    const paddingTopInner = parseInt($(view.publicVars.cssId.robloxLightboxInnerId).css('padding-top'));
                    const paddingBottomInner = parseInt($(view.publicVars.cssId.robloxLightboxInnerId).css('padding-bottom'));
                    const paddingLeftInner = parseInt($(view.publicVars.cssId.robloxLightboxInnerId).css('padding-left'));
                    const paddingRightInner = parseInt($(view.publicVars.cssId.robloxLightboxInnerId).css('padding-right'));

                    const topModifier = (- parseInt($(view.publicVars.cssId.robloxLightboxCloseId).css('top'))) * 2;
                    const rightModifier = (- parseInt($(view.publicVars.cssId.robloxLightboxCloseId).css('right'))) * 2;

                    const maxWidth = windowWidth - paddingLeft - paddingRight - paddingLeftInner - paddingRightInner - rightModifier;
                    const maxHeight = windowHeight - paddingTop - paddingBottom - paddingTopInner - paddingBottomInner - topModifier;

                    // const maxWidth = windowWidth;
                    // const maxHeight = windowHeight;

                    let lightboxSize;

                    let adjustedWidth = view.privateVars.videoSize.width;
                    let adjustedHeight = view.privateVars.videoSize.height;

                    if (width !== '' && height !== '' && parseInt(width) >= 400 && parseInt(height) >= 400) {
                        adjustedWidth = parseInt(width);
                        adjustedHeight = parseInt(height);
                    }

                    //adjustedWidth = adjustedWidth + paddingLeft + paddingRight;
                    //adjustedHeight = adjustedHeight + paddingTop + paddingBottom;

                    lightboxSize = view.methods.calculateSizeProportionForMaxValues(maxWidth, maxHeight,
                        adjustedWidth, adjustedHeight);

                    const newWidth = lightboxSize.width + paddingLeft + paddingRight + paddingLeftInner + paddingRightInner;
                    const newHeight = lightboxSize.height + paddingTop + paddingBottom + paddingTopInner + paddingBottomInner;

                    $(view.publicVars.cssId.robloxLightboxAreaId)
                        .css({width: newWidth + 'px', height: newHeight + 'px'});

                },

                calculateSizeProportionForMaxValues: (maxWidth, maxHeight, width, height) => {

                    if (width <= maxWidth && height <= maxHeight) {
                        return {width: width, height: height};
                    }

                    const widthHeightRatio = width / height;
                    const heightWidthRatio = height / width;

                    if (width > maxWidth) {

                        const widthDiff = width - maxWidth;
                        width = maxWidth;
                        height = height - (heightWidthRatio * widthDiff);
                    }

                    if (height > maxHeight) {
                        const heightDiff = height - maxHeight;
                        height = maxHeight;

                        width = width - (widthHeightRatio * heightDiff);
                    }

                    return {width: width, height: height};
                }
            };

            /* custom events */
            // pubSub.subscribe('view/actionShowSaveThxMsg', view.methods.form.actionShowSaveThxMsg);
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    lightbox.init(options.lightboxSetup);
                    view.init(options);
                    scroll.init();

                }
            };


        })();

        return module;


    });
